import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiMenu, FiX } = FiIcons;
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  const navLinks = [
    { name: 'Úvod', path: '/' },
    { name: 'Produkty', path: '/produkty/ledbary' },
    { name: 'Technologie', path: '/technologie' },
    { name: 'Know-how', path: '/know-how' },
    { name: 'O nás', path: '/o-nas' },
  ];

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isOpen]);

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <nav className="fixed w-full z-50 bg-white/90 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} className="flex-shrink-0">
            <Link to="/" className="flex flex-col">
              <img src="https://www.lightwell.cz/media/logo-lightwell.webp" alt="LightWell" className="h-10 w-auto object-contain" />
              <span className="hidden sm:block text-[7px] font-bold text-gray-400 uppercase tracking-[0.2em] -mt-1 ml-0.5">Světelná reklama a LED panely</span>
            </Link>
          </motion.div>
          
          <div className="hidden lg:flex space-x-8 items-center">
            {navLinks.map((link) => (
              <Link 
                key={link.path} 
                to={link.path} 
                className={`text-[11px] uppercase tracking-wider font-bold transition-colors ${isActive(link.path) ? 'text-blue-600' : 'text-gray-500 hover:text-blue-600'}`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/kontakt" className="px-6 py-2.5 bg-blue-600 text-white rounded-full text-[11px] uppercase tracking-wider font-bold hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/20">
              Kontakt
            </Link>
          </div>

          <div className="lg:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 text-gray-600 hover:text-blue-600 transition-colors focus:outline-none"
              aria-label="Toggle menu"
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-8 h-8" />
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="lg:hidden bg-white/95 backdrop-blur-lg border-b border-gray-100 overflow-hidden shadow-2xl"
          >
            <div className="px-4 pt-4 pb-8 space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block px-4 py-4 text-sm uppercase tracking-widest font-bold rounded-2xl transition-all ${
                    isActive(link.path) 
                      ? 'bg-blue-50 text-blue-600' 
                      : 'text-gray-600 hover:bg-gray-50 hover:text-blue-600'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="pt-4 px-2">
                <Link
                  to="/kontakt"
                  className="block w-full py-5 bg-blue-600 text-white text-center rounded-2xl text-[11px] uppercase tracking-widest font-bold hover:bg-blue-700 transition-all shadow-xl shadow-blue-600/20"
                >
                  Kontakt
                </Link>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;